module.exports = __webpack_public_path__ + "static/media/top5.97501498.webp";